import { initHelpImageMap } from './help-image-map';
import { initNotificationsAdmin } from './notifications-admin';
import { initNotificationsPanel } from './notifications-panel';
import { initRolesAddEdit } from './roles-add-edit';
import { initSettingsModuleListOrder } from './settings-module';
import { initSystemSettings } from './settings-system';
import { initSettingsUser } from './settings-user';
import { initSignInFocus, initSignInTotp } from './sign-in';
import { initSendPasswordRedirect } from './sign-send-password';
import { initSignTotpSetup } from './sign-totp';
import { initUsersAddEdit } from './users-add-edit';
import { initUsersList } from './users-list';
import { initUsersPreview } from './users-preview';
import { initUsernameFromName } from './users-username-from-name';

type PageInitializer = (root: HTMLElement) => void;

const pageInitializers: Record<string, PageInitializer> = {
    'users-add-edit': initUsersAddEdit,
    'roles-add-edit': initRolesAddEdit,
    'users-list': initUsersList,
    'users-preview': initUsersPreview,
    'sign-in': () => {
        initSignInFocus();
        initSignInTotp();
    },
    'sign-totp': initSignTotpSetup,
    'sign-send-password': initSendPasswordRedirect,
    'notifications-panel': initNotificationsPanel,
    'notifications-admin': initNotificationsAdmin,
    'settings-system': initSystemSettings,
    'settings-module': initSettingsModuleListOrder,
    'settings-user': initSettingsUser,
    'help-image-map': initHelpImageMap,
};

export function initSystemModule(): void {
    document.querySelectorAll<HTMLElement>('[data-system-page]').forEach((root) => {
        const page = root.dataset.systemPage ?? '';
        const initializer = pageInitializers[page];

        if (initializer) {
            initializer(root);
        }
    });

    initUsernameFromName();
}

declare global {
    interface Window {
        checkDns?: () => void;
        generateKeys?: () => void;
        showColorPicker?: (el: HTMLElement, useElementValueColor?: boolean) => void;
        submitTotp?: () => boolean;
    }
}
